import * as FaIcons from "react-icons/fa";

const FaWhatsapp = FaIcons.FaWhatsapp as unknown as React.FC<{ className?: string }>;
const FaEnvelope = FaIcons.FaEnvelope as unknown as React.FC<{ className?: string }>;
const FaMapMarkerAlt = FaIcons.FaMapMarkerAlt as unknown as React.FC<{ className?: string }>;



const PHONE = "56975239696";
const WHATSAPP_TEXT = encodeURIComponent("¡Hola Muriel! Quiero coordinar unos días de arriendo.");
const EMAIL = "murysotomayor@gmail.com";

export default function FloatingCta() {
  return (
    <div className="fixed bottom-6 right-6 flex flex-col gap-3 z-50">
      <a
        href={`https://wa.me/${PHONE}?text=${WHATSAPP_TEXT}`}
        target="_blank"
        rel="noopener noreferrer"
        className="group w-14 h-14 rounded-full bg-green-500 hover:bg-green-600 shadow-lg flex items-center justify-center transition"
        aria-label="Contactar por WhatsApp"
      >
        <FaWhatsapp className="text-white text-2xl group-hover:scale-110 transition" />
      </a>

      <a
        href={`mailto:${EMAIL}`}
        className="group w-14 h-14 rounded-full bg-blue-500 hover:bg-blue-600 shadow-lg flex items-center justify-center transition"
        aria-label="Contactar por correo"
      >
        <FaEnvelope className="text-white text-2xl group-hover:scale-110 transition" />
      </a>
    </div>
  );
}
